import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, Button, Loader } from "semantic-ui-react";
import { useGetDraft, useCreateDraft, useNavigation } from "../../hooks";

export const DuplicateDraftWindow = ({ draft, draftId, onClose }) => {
  const [isSubmitting, setSubmitting] = useState(false);
  const navigation = useNavigation();
  const { data: fetchedDraft, isLoading } = useGetDraft(draftId);
  const { data: createdDraft, mutate: createDraft } = useCreateDraft();

  const isLoadingData = !draft && isLoading;

  const handleConfirm = () => {
    setSubmitting(true);
    const draftToCopy = draft || fetchedDraft;
    const draftToCopyMetadata = draftToCopy.metadata || {};
    const draftToCopyTitle =
      draftToCopyMetadata.titles[0]?.titleText || "Copied Draft";
    const copyMetadata = {
      ...draftToCopyMetadata,
      titles: [
        {
          titleLanguage: "eng",
          titleText: `${draftToCopyTitle} (Copy)`,
        },
      ],
    };
    const dataCopy = {
      ...draftToCopy,
      metadata: { ...copyMetadata },
    };
    createDraft(dataCopy, {
      onSuccess: (data) => {
        setSubmitting(false);
        onClose();
        if (data && data.links && data.links.self_html) {
          navigation.navigateToUrl(data.links.self_html);
        } else {
          alert("Draft created, but no edit link was provided.");
        }
      },
      onError: (e) => {
        alert(`An error occurred while duplicating the draft: ${e.message}`);
        setSubmitting(false);
      },
    });
  };

  const handleCancel = () => {
    onClose();
  };

  const draftToDisplay = draft || fetchedDraft;

  return (
    <Modal open onClose={onClose}>
      <Modal.Header>Duplicate Draft</Modal.Header>
      <Modal.Content>
        {isLoadingData ? (
          <Loader active inline="centered" />
        ) : (
          <p>Are you sure you want to duplicate this draft?</p>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleCancel} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button
          color="green"
          onClick={handleConfirm}
          loading={isSubmitting}
          disabled={isLoadingData || isSubmitting || !draftToDisplay}
        >
          Confirm
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

DuplicateDraftWindow.propTypes = {
  draft: PropTypes.object,
  draftId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
